import { errorInterceptor } from './error.interceptor';
import { headerInterceptor } from './header.interceptor';
import { regionInterceptor } from './region.interceptor';

// Retried requests pass through headerInterceptor again to pick up the refreshed token.
export const httpInterceptors = [regionInterceptor, errorInterceptor, headerInterceptor];
